import * as d3 from 'd3-selection'
import * as colors from 'colors'

const base = chartId => {
  return `
    <!--     Gradients for the background shape  -->
    <linearGradient id="${chartId}-beaker-background-a" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="1" stop-color="#555" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="${chartId}-beaker-background-b">
      <stop offset="0" stop-color="white" stop-opacity="0.5"/>
      <stop offset="0.07" stop-color="white" stop-opacity="0.1"/>
      <stop offset="0.1" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.17" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.25" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.30" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.36" stop-color="white" stop-opacity="0"/>
      <stop offset="0.67" stop-color="white" stop-opacity="0"/>
      <stop offset="0.77" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="0.84" stop-color="white" stop-opacity="0.05"/>
      <stop offset="0.89" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>

    <!--     Gradients for the background lid -->
    <linearGradient id="${chartId}-beaker-lid-a" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="1" stop-color="#555" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="${chartId}-beaker-lid-b" x1="1" y1="0" x2="0" y2="0">
      <stop offset="0" stop-color="white" stop-opacity="0.5"/>
      <stop offset="0.07" stop-color="white" stop-opacity="0.1"/>
      <stop offset="0.1" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.17" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.25" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.30" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.36" stop-color="white" stop-opacity="0"/>
      <stop offset="0.67" stop-color="white" stop-opacity="0"/>
      <stop offset="0.77" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="0.84" stop-color="white" stop-opacity="0.05"/>
      <stop offset="0.89" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="${chartId}-beaker-lid-outline" x1="0" x2="1">
      <stop offset="0" stop-color="#555" stop-opacity=".05"/>
      <stop offset="0.5" stop-color="#777" stop-opacity=".2"/>
      <stop offset="1" stop-color="white" stop-opacity=".5"/>
    </linearGradient>

    <!--     Gradients for the foreground  -->
    <linearGradient id="${chartId}-beaker-foreground-fill">
      <stop offset="0" stop-color="white" stop-opacity="0.5"/>
      <stop offset="0.07" stop-color="white" stop-opacity="0.1"/>
      <stop offset="0.1" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.17" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.25" stop-color="white" stop-opacity="0.3"/>
      <stop offset="0.30" stop-color="#555" stop-opacity="0"/>
      <stop offset="0.36" stop-color="white" stop-opacity="0"/>
      <stop offset="0.67" stop-color="white" stop-opacity="0"/>
      <stop offset="0.77" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="0.84" stop-color="white" stop-opacity="0.05"/>
      <stop offset="0.89" stop-color="#555" stop-opacity="0.1"/>
      <stop offset="0.97" stop-color="#555" stop-opacity="0.2"/>
      <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="${chartId}-beaker-foreground-outline">
      <stop offset="0" stop-color="white" stop-opacity=".5"/>
      <stop offset="0.5" stop-color="#777" stop-opacity=".2"/>
      <stop offset="1" stop-opacity=".05" stop-color="#555"/>
    </linearGradient>

    <!-- filter used by the top lid -->
    <filter id="${chartId}-beaker-top-highlight-filter">
      <feOffset dx="0" dy="-3" />
      <feGaussianBlur result="offset-blur" stdDeviation="3" />
      <feComposite operator="out" in="SourceAlpha" in2="offset-blur" result="inverse" />
      <feFlood result="color" flood-color="white"></feFlood>
      <feComposite operator="in" in="color" in2="inverse" result="test" />
    </filter>
  `
}


/*
 * This adds the gradients used by all beakers. These gradients are not unique
 * to individual beakers, so we just build group one per chart.
 */
export default (selection, serieColors, chartId) => {
  selection.each(function (d) {
    let group = d3.select(this)
                  .selectAll('g.beaker-gradients')
                  .data([d])

    group = group.enter()
                 .append('g')
                 .attr('class', 'beaker-gradients')
                 .html(base(chartId))
                 .merge(group)

    // Gradients used by the fills
    let grad = group.selectAll('.beaker-colored-gradient')
                    .data(() => {
                      return serieColors.map(color => {
                        return [{
                          color,
                          id: `${chartId}-beaker-colored-gradient-body-a-${color}`,
                          clazz: `beaker-body-a-${color}`,
                          type: 'linearGradient',
                          x1: 0, x2: 1, y1: .4, y2: .6,
                          stopColors: [
                            colors.adjustLightness(colors.lookup(color), 40),
                            colors.adjustLightness(colors.lookup(color), 5),
                            colors.adjustLightness(colors.lookup(color), -15)
                          ]
                        }, {
                          color,
                          id: `${chartId}-beaker-colored-gradient-body-b-${color}`,
                          clazz: `beaker-body-b-${color}`,
                          type: 'linearGradient',
                          x1: .5, x2: .5, y1: 0, y2: 1,
                          stopColors: [
                            colors.changeColor(colors.adjustLightness(colors.lookup(color), 60), .2),
                            colors.changeColor(colors.adjustLightness(colors.lookup(color), 5), .22),
                            colors.changeColor(colors.adjustLightness(colors.lookup(color), -25), .25)
                          ]
                        }, {
                          color,
                          id: `${chartId}-beaker-colored-gradient-top-${color}`,
                          clazz: `beaker-top-${color}`,
                          type: 'linearGradient',
                          x1: 0, x2: 1, y1: .8, y2: .2,
                          stopColors: [
                            colors.adjustLightness(colors.lookup(color), 50),
                            colors.adjustLightness(colors.lookup(color), 5),
                            colors.adjustLightness(colors.lookup(color), 15)
                          ]
                        }, {
                          color,
                          id: `${chartId}-beaker-colored-gradient-top-highlight-${color}`,
                          clazz: `beaker-top-highlight-${color}`,
                          type: 'linearGradient',
                          stopColors: [],
                          x1: .5, x2: .5, y1: 0, y2: 1
                        }]
                      }).flat()
                    }, d => d.color)
      , gradEnter = grad.enter()
                        .append(d => {
                           return document.createElementNS('http://www.w3.org/2000/svg', d.type)
                        })
                        .attr('class', d => `beaker-colored-gradient ${d.clazz}`)
                        .attr('id', d => d.id)
                        .attr('x1', d => d.x1)
                        .attr('x2', d => d.x2)
                        .attr('y1', d => d.y1)
                        .attr('y2', d => d.y2)

    gradEnter.append('stop')
             .attr('offset', 0)
             .attr('stop-color', d => d.stopColors[0])
    gradEnter.append('stop')
             .attr('offset', .5)
             .attr('stop-color', d => d.stopColors[1])
    gradEnter.append('stop')
             .attr('offset', 1)
             .attr('stop-color', d => d.stopColors[2])

    grad.exit().remove()
  })
}
